import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table,
} from 'antd';
import dayjs from 'dayjs';
import { toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';
import './style.scss';
import H3Modal from '@Uilib/H3Modal';
import ViewSalesOrder from '@Components/Sales/SalesOrder/ViewSalesOrder';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
/**
 * @param status
 */
class SalesOrdersList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      limit: 10,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      openPurchaseOrderModal: false,
      openGRNModal: false,
      openGRNModalView: false,
      openUpdatePurchaseOrderModal: false,
      expandedRowKeys: [],
      tableColumns: [
        {
          title: 'SO #',
          dataIndex: 'sales_order_number',
        },
        {
          title: 'BUSINESS UNIT',
          render: (text, record) => (
            <Fragment>
              <div
                style={{
                  color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer',
                }}
              >
                {record.tenant_info?.tenant_name}
              </div>
            </Fragment>
          ),
        },
        {
          title: 'CUSTOMER',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <div
                className="company__name"
                style={{
                  color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer',
                }}
              >
                {record?.customer_info?.customer_name}
              </div>
            );
          },
        },
        {
          title: 'ITEMS',
          render: (item) => item?.no_of_items,
        },
        {
          title: 'ORDER DATE',
          render: (record) => (
            <div>
              {toISTDate(record?.order_date).format('DD/MM/YYYY')}
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
        },
        {
          title: 'DELIVERY DATE',
          render: (record) => (
            <Fragment>
              {toISTDate(record?.delivery_date).format('DD/MM/YYYY')}
            </Fragment>
          ),
        },
        {
          title: 'ORDER TOTAL AMOUNT',
          render: (item, record) => this.props.MONEY(record?.order_grand_total || '0'),
        },
        {
          title: '',
          key: 'action',
          fixed: 'right',
          render: (record) => (
            <div style={{
              textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}
            >
              <div className="table__view-button" onClick={() => this.setState({ selectedSalesOrder: record, showSoModal: true })}>
                View
              </div>
            </div>
          ),
        },
      ],
      documentUINames: {},
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions('map_so', 10, state.currentPage, () => {});
      return {
        ...state,
        documentUINames: documentUINamesConstant(props.user),
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @param {*} status
   * @return
   */
  render() {
    const {
      pendingActions, getPendingActionsLoading, getPendingActions,
    } = this.props;
    const {
      currentPage, tableColumns, showSoModal, selectedSalesOrder, documentUINames,
    } = this.state;
    return (
      <Fragment>
        <div className="purchase-request__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="generic-table-container">
                <Table
                  title={() => (
                    <div className="purchase-request__table-header">
                      {`${Number(pendingActions?.so_approval_count)} ${documentUINames.salesOrderUIName || 'Sales Order'}s`}
                    </div>
                  )}
                  loading={getPendingActionsLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={tableColumns}
                  rowKey="po_id"
                  dataSource={pendingActions?.sales_orders || []}
                  pagination={(Number(pendingActions?.so_approval_count) > 10) ? {
                    defaultCurrent: 1,
                    current: currentPage,
                    total: Number(pendingActions?.so_approval_count),
                    pageSize: 10,
                    onChange: (page) => {
                      getPendingActions('map_so', 10, currentPage, () => {});
                      this.setState({ currentPage: page });
                    },
                    position: ['bottomRight'],
                    showSizeChanger: false,
                  } : false}
                />
              </div>
            </div>
          </div>
        </div>
        <H3Modal
          onClose={() => {
            getPendingActions('map_so', 10, currentPage, () => {});
            this.setState({ showSoModal: false });
          }}
          className="pending-po__view-po"
          isOpen={showSoModal}
          title={`${documentUINames.salesOrderUIName || 'Sales Order'} #${selectedSalesOrder ? selectedSalesOrder?.order_id : ''} for ${selectedSalesOrder?.tenant_info?.tenant_name}`}
          showHeader
        >
          <ViewSalesOrder isQuickView selectedSoId={selectedSalesOrder?.order_id} selectedTenantId={selectedSalesOrder?.tenant_info?.tenant_id} />
        </H3Modal>
      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseRequestReducers
 * @return {{purchaseRequests: *, getPurchaseRequestsLoading: *, user}}
 */
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});

SalesOrdersList.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesOrdersList));
